import React from 'react'
import { InstallType, mobileInstallTypes, useFirstEligibleInstall } from '../../../../lib/hooks/install-eligibility'
import { NotAvailableButton } from '../unsupported/not-available-button'
import { AndroidInstallButton } from './android'
import { KeyboardInstallButtonCtaProps } from './base'
import { IPhoneInstallButton, IPadInstallButton } from './ios'

export interface KeyboardInstallButtonProps extends KeyboardInstallButtonCtaProps {
  onClick?: () => void
}

export const KeyboardInstallButton: React.FC<KeyboardInstallButtonProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall(mobileInstallTypes)

  switch (preferredInstall) {
    case InstallType.IPad:
      return <IPadInstallButton {...props} />
    case InstallType.IPhone:
      return <IPhoneInstallButton {...props} />
    case InstallType.Android:
      return <AndroidInstallButton {...props} />
    default:
      return <NotAvailableButton {...props} />
  }
}
